// test1101
(1101 && 0);
